import { createApp } from 'vue'
import myLoad, { useLoadingEffect } from '@/components/MyLoading.vue'
import { Loading } from 'vant';

const { msg } = useLoadingEffect()
//步骤
// 1.有个loading 的vue
// 2.挂载到父节点上  上树
// 3.挂载到全局的vue上
// 4.可以引用显示隐藏 即可处理。
// 既然是vue想要的效果的话,那就走这一套就行了。

// 走vue识别的那一套 的话 就需要 让vue识别 那就是createApp。然后挂载到节点上去。
const $loading = createApp(myLoad, { msg }).use(Loading).mount(document.createElement('div'))
console.log('$loading', $loading.$el);
document.body.appendChild($loading.$el)
const load = {
    show() { // 控制显示loading的方法
        msg.show = true
        setTimeout(() => {
            this.hide()
        }, 10000);
    },

    hide() { // 控制loading隐藏的方法
        msg.show = false
    }
}
export { load }

